// Where a row in the Hazards block goes: the trail's own page on this
// website. Published hazards carry the trail's slug; a crew note is a
// trail row already; a hazard typed into the block names its trail in
// words, so it links when that name is one of the site's trails.
export function trailPageHref(slug) {
    return slug ? `/trails/${slug}` : null;
}

export function trailHrefByName(siteData, name) {
    const want = String(name || '').trim().toLowerCase();
    if (!want) return null;
    const t = (siteData?.trails || []).find((row) => String(row.name || '').trim().toLowerCase() === want);
    return trailPageHref(t?.slug);
}
